import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import { withAnalyticsEvents } from '@atlaskit/analytics-next';
import { withMediaAnalyticsContext } from '@atlaskit/media-common';
import isValidId from 'uuid-validate';
import { LocalUploadComponentReact } from '../localUploadReact';
import { getPackageAttributes } from '../../util/analytics';
import ErrorFlagGroup from '../errorFlagGroup/ErrorFlagGroup';
var defaultConfig = {
  uploadParams: {}
};
var COMPONENT_NAME = 'browser';
export var BrowserBase = /*#__PURE__*/function (_LocalUploadComponent) {
  function BrowserBase(props) {
    var _this;
    _classCallCheck(this, BrowserBase);
    _this = _callSuper(this, BrowserBase, [props, COMPONENT_NAME]);
    _defineProperty(_this, "browserRef", /*#__PURE__*/React.createRef());
    _defineProperty(_this, "onFilePicked", function (event) {
      if (!event.target) {
        return;
      }
      var replaceFileId = _this.props.config.replaceFileId;
      var filesArray = [].slice.call(event.target.files);

      // refreshes uploadParams as only set once in parent constructor
      _this.setUploadParams(_this.props.config.uploadParams);
      try {
        if (replaceFileId) {
          _this.uploadService.addFile(filesArray[0], replaceFileId);
        } else {
          _this.uploadService.addFiles(filesArray);
        }
      } finally {
        if (_this.browserRef.current) {
          _this.browserRef.current.value = '';
        }
      }
    });
    _defineProperty(_this, "browse", function () {
      var onClose = _this.props.onClose;
      if (!_this.browserRef.current) {
        return;
      }
      _this.browserRef.current.click();
      // Calling onClose directly since there is no dom api to notify us when
      // the native file picker is closed
      if (onClose) {
        onClose();
      }
    });
    var config = props.config,
      onError = props.onError;
    var _replaceFileId = config.replaceFileId;
    if (_replaceFileId && !isValidId(_replaceFileId)) {
      _this.createAndFireAnalyticsEvent({
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaUpload',
        actionSubjectId: 'localMedia',
        attributes: {
          status: 'fail',
          failReason: 'invalid_uuid',
          uuid: _replaceFileId
        }
      });
      onError && onError({
        fileId: _replaceFileId,
        error: {
          description: 'Invalid replaceFileId format',
          name: 'invalid_uuid',
          fileId: _replaceFileId
        }
      });
    }
    return _this;
  }
  _inherits(BrowserBase, _LocalUploadComponent);
  return _createClass(BrowserBase, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        onBrowseFn = _this$props.onBrowseFn,
        onCancelFn = _this$props.onCancelFn,
        isOpen = _this$props.isOpen;
      if (onBrowseFn) {
        onBrowseFn(this.browse);
      }
      if (onCancelFn) {
        onCancelFn(this.cancel);
      }
      if (isOpen) {
        this.browse();
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var isOpen = this.props.isOpen;
      var nextIsOpen = nextProps.isOpen;
      if (nextIsOpen && nextIsOpen !== isOpen) {
        this.browse();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        config = _this$props2.config,
        children = _this$props2.children;
      var multiple = config.multiple,
        replaceFileId = config.replaceFileId;
      var fileExtensions = config.fileExtensions && config.fileExtensions.join(',');
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", {
        "data-testid": "media-picker-file-input",
        ref: this.browserRef,
        type: "file"
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        ,
        style: {
          display: 'none'
        },
        multiple: replaceFileId ? false : multiple /* if the consumer passes the fileId we must work in single selection mode */,
        accept: fileExtensions,
        onChange: this.onFilePicked
      }), children ? children(this.browse) : null, /*#__PURE__*/React.createElement(ErrorFlagGroup, {
        flagData: this.state.errorFlags,
        onFlagDismissed: this.dismissErrorFlag
      }));
    }
  }]);
}(LocalUploadComponentReact);
_defineProperty(BrowserBase, "defaultProps", {
  config: defaultConfig
});
export default BrowserBase;
export var Browser = withMediaAnalyticsContext(getPackageAttributes(COMPONENT_NAME))(withAnalyticsEvents()(BrowserBase));